var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "app-container" },
    [
      _c(
        "div",
        { staticClass: "filter-container" },
        [
          _c("el-input", {
            staticClass: "filter-item",
            staticStyle: { width: "200px" },
            attrs: { type: "text", placeholder: "请输入app版本" },
            model: {
              value: _vm.searchData.appVersion,
              callback: function($$v) {
                _vm.$set(_vm.searchData, "appVersion", $$v)
              },
              expression: "searchData.appVersion"
            }
          }),
          _vm._v(" "),
          _c(
            "el-select",
            {
              staticClass: "filter-item",
              staticStyle: { width: "200px" },
              attrs: {
                filterable: "",
                clearable: "",
                placeholder: "请选择app",
                "remote-method": _vm.appFun,
                remote: "",
                "reserve-keyword": ""
              },
              on: { focus: _vm.getdrop },
              model: {
                value: _vm.searchData.appId,
                callback: function($$v) {
                  _vm.$set(_vm.searchData, "appId", $$v)
                },
                expression: "searchData.appId"
              }
            },
            _vm._l(_vm.droplist, function(item, index) {
              return _c("el-option", {
                key: index,
                attrs: { label: item.name, value: item.appId }
              })
            }),
            1
          ),
          _vm._v(" "),
          _c(
            "el-select",
            {
              staticClass: "filter-item",
              staticStyle: { width: "200px" },
              attrs: {
                placeholder: "请选择是否强制",
                filterable: "",
                clearable: ""
              },
              model: {
                value: _vm.searchData.isForce,
                callback: function($$v) {
                  _vm.$set(_vm.searchData, "isForce", $$v)
                },
                expression: "searchData.isForce"
              }
            },
            [
              _c("el-option", { attrs: { label: "强制", value: 1 } }),
              _vm._v(" "),
              _c("el-option", { attrs: { label: "不强制", value: 0 } })
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-select",
            {
              staticClass: "filter-item",
              staticStyle: { width: "200px" },
              attrs: { placeholder: "请选择是否启用", clearable: "" },
              model: {
                value: _vm.searchData.enabled,
                callback: function($$v) {
                  _vm.$set(_vm.searchData, "enabled", $$v)
                },
                expression: "searchData.enabled"
              }
            },
            [
              _c("el-option", { attrs: { label: "启用", value: 1 } }),
              _vm._v(" "),
              _c("el-option", { attrs: { label: "不启用", value: 0 } })
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-select",
            {
              staticClass: "filter-item",
              staticStyle: { width: "200px" },
              attrs: { placeholder: "请选择系统类型", clearable: "" },
              model: {
                value: _vm.searchData.sysType,
                callback: function($$v) {
                  _vm.$set(_vm.searchData, "sysType", $$v)
                },
                expression: "searchData.sysType"
              }
            },
            _vm._l(_vm.sysTypeList, function(item, index) {
              return _c("el-option", {
                key: index,
                attrs: { label: item.name, value: item.id }
              })
            }),
            1
          ),
          _vm._v(" "),
          _c(
            "el-button",
            {
              staticClass: "filter-item",
              attrs: { type: "primary", icon: "el-icon-search" },
              on: { click: _vm.searchFun }
            },
            [_vm._v("查询")]
          ),
          _vm._v(" "),
          _vm.checkPermission(["app:version:add"])
            ? _c(
                "el-button",
                {
                  staticClass: "filter-item",
                  attrs: { type: "primary", icon: "el-icon-plus" },
                  on: { click: _vm.addFun }
                },
                [_vm._v("新增")]
              )
            : _vm._e(),
          _vm._v(" "),
          _c(
            "el-button",
            {
              staticClass: "filter-item",
              attrs: { type: "warning", icon: "el-icon-refresh" },
              on: { click: _vm.resetFun }
            },
            [_vm._v("重置")]
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-dropdown",
        [
          _c("el-button", { attrs: { type: "primary", scoped: "" } }, [
            _vm._v("\n      显示/隐藏列\n      "),
            _c("i", { staticClass: "el-icon-arrow-down el-icon--right" })
          ]),
          _vm._v(" "),
          _c(
            "el-dropdown-menu",
            { attrs: { slot: "dropdown" }, slot: "dropdown" },
            _vm._l(_vm.tableColumns, function(column, index) {
              return _c(
                "el-dropdown-item",
                {
                  key: index,
                  nativeOn: {
                    click: function($event) {
                      return _vm.showHide(column.isShow)
                    }
                  }
                },
                [
                  _c(
                    "el-checkbox",
                    {
                      model: {
                        value: column.isShow,
                        callback: function($$v) {
                          _vm.$set(column, "isShow", $$v)
                        },
                        expression: "column.isShow"
                      }
                    },
                    [_vm._v(_vm._s(column.label))]
                  )
                ],
                1
              )
            }),
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-table",
        {
          attrs: {
            data: _vm.tableData,
            border: "",
            stripe: "",
            "cell-style": _vm.isCenter,
            "header-cell-style": _vm.isCenter,
            "highlight-current-row": ""
          }
        },
        [
          _c("el-table-column", {
            attrs: { type: "index", label: "序号", width: "50" }
          }),
          _vm._v(" "),
          _vm._l(_vm.tableColumns, function(column, index) {
            return [
              column.isShow
                ? _c("el-table-column", {
                    key: index,
                    attrs: {
                      prop: column.prop,
                      label: column.label,
                      formatter: column.formatter,
                      width: column.width,
                      sortable: column.sortable
                    }
                  })
                : _vm._e()
            ]
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: { label: "操作", width: "560", prop: "" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(scope) {
                  return [
                    _vm.checkPermission(["app:version:updata"])
                      ? _c(
                          "el-button",
                          {
                            attrs: {
                              type: "primary",
                              title: "编辑",
                              size: "mini"
                            },
                            on: {
                              click: function($event) {
                                return _vm.updateMenu(scope.row)
                              }
                            }
                          },
                          [_vm._v("编辑")]
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.checkPermission(["app:version:del"])
                      ? _c(
                          "el-button",
                          {
                            attrs: {
                              type: "danger",
                              title: "删除",
                              size: "mini"
                            },
                            on: {
                              click: function($event) {
                                return _vm.delMenu(scope.row)
                              }
                            }
                          },
                          [_vm._v("删除")]
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.checkPermission(["app:version:enabled"])
                      ? _c(
                          "el-button",
                          {
                            attrs: {
                              type: "success",
                              title: "启用",
                              size: "mini"
                            },
                            on: {
                              click: function($event) {
                                return _vm.auditFun(scope.row)
                              }
                            }
                          },
                          [_vm._v("启用")]
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.checkPermission(["app:version:enabled2"])
                      ? _c(
                          "el-button",
                          {
                            attrs: {
                              type: "info",
                              title: "禁用",
                              size: "mini"
                            },
                            on: {
                              click: function($event) {
                                return _vm.auditFun2(scope.row)
                              }
                            }
                          },
                          [_vm._v("禁用")]
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.checkPermission(["app:version:force"])
                      ? _c(
                          "el-button",
                          {
                            attrs: {
                              type: "warning",
                              title: "强制",
                              size: "mini"
                            },
                            on: {
                              click: function($event) {
                                return _vm.forceFun(scope.row)
                              }
                            }
                          },
                          [_vm._v("强制")]
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.checkPermission(["app:version:force2"])
                      ? _c(
                          "el-button",
                          {
                            attrs: {
                              type: "info",
                              title: "不强制",
                              size: "mini"
                            },
                            on: {
                              click: function($event) {
                                return _vm.forceFun2(scope.row)
                              }
                            }
                          },
                          [_vm._v("不强制")]
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _c(
                      "router-link",
                      {
                        attrs: {
                          to: "/edition/editionlistdetail/" + scope.row.id
                        }
                      },
                      [
                        _c(
                          "el-button",
                          { attrs: { title: "多国语言", size: "mini" } },
                          [_vm._v("多国语言")]
                        )
                      ],
                      1
                    )
                  ]
                }
              }
            ])
          })
        ],
        2
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "pagination-container" },
        [
          _c("el-pagination", {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.pageData.total > 0,
                expression: "pageData.total>0"
              }
            ],
            attrs: {
              "current-page": _vm.pageData.page,
              "page-sizes": [10, 20, 30, 40, 50, 100, 200, 300, 400, 500],
              "page-size": _vm.pageData.rows,
              layout: "total, sizes, prev, pager, next, jumper",
              total: _vm.pageData.total
            },
            on: {
              "size-change": _vm.handleSizeChange,
              "current-change": _vm.handleCurrentChange
            }
          })
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-dialog",
        {
          attrs: {
            title: _vm.title,
            width: "600px",
            visible: _vm.newadd,
            close: _vm.onCencal,
            center: ""
          },
          on: {
            "update:visible": function($event) {
              _vm.newadd = $event
            }
          }
        },
        [
          _c(
            "el-form",
            {
              ref: "addForm",
              attrs: {
                model: _vm.addData,
                rules: _vm.rules,
                "label-width": "160px"
              }
            },
            [
              _c(
                "el-form-item",
                { attrs: { label: "app", prop: "appId" } },
                [
                  _c(
                    "el-select",
                    {
                      attrs: {
                        filterable: "",
                        placeholder: "请选择",
                        "remote-method": _vm.appFun,
                        remote: "",
                        "reserve-keyword": ""
                      },
                      on: { change: _vm.onAppIdChange, focus: _vm.getdrop },
                      model: {
                        value: _vm.addData.appId,
                        callback: function($$v) {
                          _vm.$set(_vm.addData, "appId", $$v)
                        },
                        expression: "addData.appId"
                      }
                    },
                    _vm._l(_vm.droplist, function(item, index) {
                      return _c("el-option", {
                        key: index,
                        attrs: { label: item.name, value: item.appId }
                      })
                    }),
                    1
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { label: "app版本号", prop: "appVersion" } },
                [
                  _c("el-input", {
                    model: {
                      value: _vm.addData.appVersion,
                      callback: function($$v) {
                        _vm.$set(_vm.addData, "appVersion", $$v)
                      },
                      expression: "addData.appVersion"
                    }
                  })
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { label: "系统类型：", prop: "sysType" } },
                [
                  _c(
                    "el-select",
                    {
                      attrs: { placeholder: "请选择", clearable: "" },
                      model: {
                        value: _vm.addData.sysType,
                        callback: function($$v) {
                          _vm.$set(_vm.addData, "sysType", $$v)
                        },
                        expression: "addData.sysType"
                      }
                    },
                    _vm._l(_vm.sysTypeList, function(item, index) {
                      return _c("el-option", {
                        key: index,
                        attrs: { label: item.name, value: item.id }
                      })
                    }),
                    1
                  )
                ],
                1
              ),
              _vm._v(" "),
              _vm.addData.appId != "" && _vm.addData.sysType == 2
                ? _c(
                    "el-form-item",
                    { attrs: { label: "上传文件", prop: "url" } },
                    [
                      _c(
                        "el-upload",
                        {
                          staticClass: "upload-demo",
                          attrs: {
                            "http-request": _vm.fnUploadRequest,
                            action: "string",
                            "before-remove": _vm.beforeRemove,
                            "on-remove": _vm.handleOnRemove,
                            "on-success": _vm.onsuccess,
                            "on-change": _vm.handleChangePic,
                            "before-upload": _vm.beforeUpload,
                            "show-file-list": false,
                            accept: "_US1"
                          }
                        },
                        [
                          _c(
                            "el-button",
                            { attrs: { size: "small", type: "primary" } },
                            [_vm._v("点击上传")]
                          ),
                          _vm._v(" "),
                          _vm.addData.url != ""
                            ? _c("div", [
                                _c("span", [_vm._v(_vm._s(_vm.addData.url))])
                              ])
                            : _vm._e()
                        ],
                        1
                      )
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { label: "提示语", prop: "notice" } },
                [
                  _c("el-input", {
                    attrs: {
                      type: "textarea",
                      rows: 5,
                      maxlength: "2048",
                      "show-word-limit": "",
                      placeholder: "版本提示语"
                    },
                    model: {
                      value: _vm.addData.notice,
                      callback: function($$v) {
                        _vm.$set(_vm.addData, "notice", $$v)
                      },
                      expression: "addData.notice"
                    }
                  })
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { label: "备注" } },
                [
                  _c("el-input", {
                    attrs: {
                      type: "textarea",
                      rows: 5,
                      maxlength: "256",
                      placeholder: "最多不能超过256个字符"
                    },
                    model: {
                      value: _vm.addData.remark,
                      callback: function($$v) {
                        _vm.$set(_vm.addData, "remark", $$v)
                      },
                      expression: "addData.remark"
                    }
                  })
                ],
                1
              ),
              _vm._v(" "),
              _vm.title == "新增"
                ? _c(
                    "el-form-item",
                    { attrs: { label: "是否禁用", prop: "enabled" } },
                    [
                      _c(
                        "el-radio",
                        {
                          attrs: { label: "0" },
                          model: {
                            value: _vm.addData.enabled,
                            callback: function($$v) {
                              _vm.$set(_vm.addData, "enabled", $$v)
                            },
                            expression: "addData.enabled"
                          }
                        },
                        [_vm._v("禁用")]
                      ),
                      _vm._v(" "),
                      _c(
                        "el-radio",
                        {
                          attrs: { label: "1" },
                          model: {
                            value: _vm.addData.enabled,
                            callback: function($$v) {
                              _vm.$set(_vm.addData, "enabled", $$v)
                            },
                            expression: "addData.enabled"
                          }
                        },
                        [_vm._v("启用")]
                      )
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.title == "新增"
                ? _c(
                    "el-form-item",
                    { attrs: { label: "是否强制", prop: "isForce" } },
                    [
                      _c(
                        "el-radio",
                        {
                          attrs: { label: "0" },
                          model: {
                            value: _vm.addData.isForce,
                            callback: function($$v) {
                              _vm.$set(_vm.addData, "isForce", $$v)
                            },
                            expression: "addData.isForce"
                          }
                        },
                        [_vm._v("不强制")]
                      ),
                      _vm._v(" "),
                      _c(
                        "el-radio",
                        {
                          attrs: { label: "1" },
                          model: {
                            value: _vm.addData.isForce,
                            callback: function($$v) {
                              _vm.$set(_vm.addData, "isForce", $$v)
                            },
                            expression: "addData.isForce"
                          }
                        },
                        [_vm._v("强制")]
                      )
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.addData.sysType != 2
                ? _c(
                    "el-form-item",
                    { attrs: { label: "是否审核中", prop: "isNeed" } },
                    [
                      _c(
                        "el-radio",
                        {
                          attrs: { label: "1" },
                          model: {
                            value: _vm.addData.isNeed,
                            callback: function($$v) {
                              _vm.$set(_vm.addData, "isNeed", $$v)
                            },
                            expression: "addData.isNeed"
                          }
                        },
                        [_vm._v("审核中")]
                      ),
                      _vm._v(" "),
                      _c(
                        "el-radio",
                        {
                          attrs: { label: "0" },
                          model: {
                            value: _vm.addData.isNeed,
                            callback: function($$v) {
                              _vm.$set(_vm.addData, "isNeed", $$v)
                            },
                            expression: "addData.isNeed"
                          }
                        },
                        [_vm._v("正常")]
                      )
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _c(
                "el-form-item",
                {
                  attrs: { label: "升级范围", prop: "rangeType", required: "" }
                },
                [
                  _c(
                    "el-radio-group",
                    {
                      model: {
                        value: _vm.addData.rangeType,
                        callback: function($$v) {
                          _vm.$set(_vm.addData, "rangeType", $$v)
                        },
                        expression: "addData.rangeType"
                      }
                    },
                    [
                      _c("el-radio", { attrs: { label: "1" } }, [
                        _vm._v(_vm._s(_vm.isOverseas ? "全域升级" : "全国升级"))
                      ]),
                      _vm._v(" "),
                      _c("el-radio", { attrs: { label: "3" } }, [
                        _vm._v("精准升级")
                      ])
                    ],
                    1
                  )
                ],
                1
              ),
              _vm._v(" "),
              parseInt(_vm.addData.rangeType) == 3
                ? _c(
                    "el-form-item",
                    { attrs: { label: "升级设备", required: "" } },
                    [
                      _c(
                        "div",
                        { staticClass: "filter-container" },
                        [
                          _c("el-input", {
                            staticClass: "filter-item",
                            staticStyle: { width: "200px" },
                            attrs: { placeholder: "设备序列号", clearable: "" },
                            model: {
                              value: _vm.deviceSn,
                              callback: function($$v) {
                                _vm.deviceSn = $$v
                              },
                              expression: "deviceSn"
                            }
                          }),
                          _vm._v(" "),
                          _c(
                            "el-button",
                            {
                              staticClass: "filter-item",
                              attrs: {
                                type: "primary",
                                icon: "el-icon-search",
                                size: "mini"
                              },
                              on: { click: _vm.fetchDeviceList }
                            },
                            [_vm._v("查询")]
                          )
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "el-table",
                        {
                          ref: "deviceTable",
                          attrs: {
                            data: _vm.deviceList,
                            border: "",
                            stripe: "",
                            "highlight-current-row": "",
                            "max-height": "300",
                            "row-key": _vm.getDeviceRowKey
                          }
                        },
                        [
                          _c("el-table-column", {
                            attrs: {
                              type: "selection",
                              width: "55",
                              selectable: _vm.tableColumnSelectable,
                              "reserve-selection": ""
                            }
                          }),
                          _vm._v(" "),
                          _vm._l(_vm.deviceTableColumns, function(item, index) {
                            return [
                              _c("el-table-column", {
                                key: index,
                                attrs: { prop: item.prop, label: item.label }
                              })
                            ]
                          })
                        ],
                        2
                      )
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.title == "新增"
                ? _c(
                    "el-form-item",
                    { attrs: { label: " " } },
                    [
                      _c(
                        "el-button",
                        {
                          attrs: { type: "primary" },
                          on: { click: _vm.onSubmit }
                        },
                        [_vm._v("提交")]
                      ),
                      _vm._v(" "),
                      _c("el-button", { on: { click: _vm.onCencal } }, [
                        _vm._v("取消")
                      ])
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.title == "编辑"
                ? _c(
                    "el-form-item",
                    { attrs: { label: " " } },
                    [
                      _c(
                        "el-button",
                        {
                          attrs: { type: "primary" },
                          on: { click: _vm.onUpdate }
                        },
                        [_vm._v("提交")]
                      ),
                      _vm._v(" "),
                      _c("el-button", { on: { click: _vm.onCencal } }, [
                        _vm._v("取消")
                      ])
                    ],
                    1
                  )
                : _vm._e()
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-dialog",
        {
          attrs: { visible: _vm.showCheckErr, center: "", width: "600px" },
          on: {
            "update:visible": function($event) {
              _vm.showCheckErr = $event
            },
            close: function($event) {
              _vm.showCheckErr = false
            }
          }
        },
        [
          _c("template", { slot: "title" }, [
            _c("div", { staticClass: "check-err-title" }, [
              _vm._v("发现AppID和上传文件名称校验不一致，请详细核对如下信息：")
            ])
          ]),
          _vm._v(" "),
          _c("div", [
            _c("div", { staticClass: "check-err-line" }, [
              _vm._v(
                "App：" +
                  _vm._s(_vm.addData.appName) +
                  "（" +
                  _vm._s(_vm.addData.appId) +
                  "）"
              )
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "check-err-line" }, [
              _vm._v("上传更新文件：" + _vm._s(_vm.addData.url))
            ])
          ]),
          _vm._v(" "),
          _c(
            "template",
            { slot: "footer" },
            [
              _c(
                "el-button",
                {
                  on: {
                    click: function($event) {
                      _vm.showCheckErr = false
                    }
                  }
                },
                [_vm._v("取消")]
              ),
              _vm._v(" "),
              _c(
                "el-button",
                {
                  attrs: { type: "primary" },
                  on: { click: _vm.checkErrSubmit }
                },
                [_vm._v("继续提交")]
              )
            ],
            1
          )
        ],
        2
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }